// test2685
(2685 && 0);
